import {createRouter, createWebHistory} from 'vue-router'
import {userAuthenticate} from "@/functions/userAuthenticate";

const routes = [
    {
        path: '/',
        redirect: '/request-otp'
    },
    {
        path: '/request-otp',
        name: 'RequestOtp',
        component: () => import("@/pages/views/RequestOtp"),
    },
    {
        path: '/submit-otp',
        name: 'SubmitOtp',
        component: () => import("@/pages/views/SubmitOtp"),
    },
    {
        path: '/error',
        name: 'ErrorPage',
        component: () => import("@/pages/views/ErrorPage"),
    },
    {
        path: '/claimed',
        name: 'VoucherClaimed',
        component: () => import("@/pages/views/VoucherClaimed"),
    },
    {
        path: '/select-voucher',
        name: 'SelectVoucher',
        component: () => import("@/pages/views/SelectVoucher"),
    },
    {
        path: '/redeem-pin',
        name: 'RedeemPin',
        component: () => import("@/pages/views/RedeemPin"),
    },
    {
        path: '/menu',
        name: 'MenuPage',
        component: () => import("@/pages/views/MenuPage"),
    },
    {
        path: '/home',
        name: 'HomePage',
        component: () => import("@/pages/components/HomePage"),
    },
    {
        path: '/coupons',
        name: 'CouponsPage',
        component: () => import("@/pages/components/CouponsPage"),
    },
    {
        path: '/coupon-validity',
        name: 'CouponValidityPage',
        component: () => import("@/pages/components/CouponValidityPage"),
    },
    {
        path: '/how-to-redeem',
        name: 'HowToRedeemPage',
        component: () => import("@/pages/components/HowToRedeemPage"),
    },
    {
        path: '/terms-conditions',
        name: 'TermsConditionsPage',
        component: () => import("@/pages/components/TermsConditionsPage"),
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach(async (to, from, next) => {
    await userAuthenticate(to, from, next)
})

export default router
